import { render } from "./admin-import-data.vue?vue&type=template&id=10b54090"
import script from "./admin-import-data.vue?vue&type=script&lang=js"
export * from "./admin-import-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-import-data.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10b54090"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10b54090', __exports__)) {
    api.reload('10b54090', __exports__)
  }
  
  module.hot.accept("./admin-import-data.vue?vue&type=template&id=10b54090", () => {
    api.rerender('10b54090', render)
  })

}


export default __exports__